/** Layout chrome roles: header is always first, footer always last. */

export const LAYOUT_HEADER = 'BlockHeader'
export const LAYOUT_FOOTER = 'BlockFooter'

export function isLayoutHeader(component: string): boolean {
  return component === LAYOUT_HEADER
}

export function isLayoutFooter(component: string): boolean {
  return component === LAYOUT_FOOTER
}

/** Non-header/non-footer layout chrome (e.g. announcement banner). */
export function isLayoutMidChrome(component: string): boolean {
  return !isLayoutHeader(component) && !isLayoutFooter(component)
}

export function partitionLayoutBlocks<T extends { component: string }>(blocks: T[]) {
  const header: T[] = []
  const middle: T[] = []
  const footer: T[] = []
  for (const block of blocks) {
    if (isLayoutHeader(block.component)) header.push(block)
    else if (isLayoutFooter(block.component)) footer.push(block)
    else middle.push(block)
  }
  return { header, middle, footer }
}

/** Canonical order: Header → mid chrome (banner…) → Footer. */
export function normalizeLayoutBlockOrder<T extends { component: string }>(blocks: T[]): T[] {
  const { header, middle, footer } = partitionLayoutBlocks(blocks)
  return [...header, ...middle, ...footer]
}
